// extracted by mini-css-extract-plugin
export default {"ourPostsCarouselContainer":"OurPostsCarousel_ourPostsCarouselContainer__Q7+1B"};